export default __webpack_public_path__ + "static/media/HDTX_Audit Report 2022.57083330.pdf";